<header class="header">
  <div class="container">
    <nav class="header-menu">
      <ul class="header-menu__list">
        <li class="header-menu__item header-menu__item--main">
          <a routerLink="/" routerLinkActive="header-menu__link--active" [routerLinkActiveOptions]="{exact: true}" class="header-menu__link" i18n>
            Voice recorder
          </a>
        </li>

        <li class="header-menu__item">
          <a href="how-to-record.html" class="header-menu__link" i18n>
            How to record
          </a>
        </li>
        <li class="header-menu__item">
          <a href="about-recorder.html" class="header-menu__link" i18n>
            About
          </a>
        </li>
        <li class="header-menu__item">
          <a href="disclaimer.html" class="header-menu__link" i18n>
            Disclaimer
          </a>
        </li>
        <li class="header-menu__item">
          <a href="feedback.html" class="header-menu__link" i18n>
            Feedback
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>



// WEBPACK FOOTER //
// ./src/app/shared/components/header/header.component.html